import { render, staticRenderFns } from "./ChangelogModal.vue?vue&type=template&id=1f1c9237&scoped=true&"
import script from "./ChangelogModal.vue?vue&type=script&lang=js&"
export * from "./ChangelogModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangelogModal.vue?vue&type=style&index=0&id=1f1c9237&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c9237",
  null
  
)

export default component.exports